import actionTypes from "../actions";

const isValidJson = (val) => {
  try {
    JSON.parse(val);
  } catch (e) {
    return {};
  }
  return JSON.parse(val);
};

// var shoppingQuoteJson = JSON.parse(window.localStorage.getItem('shoppingQuote'));
var shoppingQuoteJson = isValidJson(
  window.localStorage.getItem("shoppingQuote"),
);

const initialState = {
  shoppingQuote: Array.isArray(shoppingQuoteJson) ? shoppingQuoteJson : [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_QUOTE: {
      window.localStorage.setItem("shoppingQuote", JSON.stringify(action.data));
      return {
        ...state,
        shoppingQuote: action.data,
      };
    }
    default:
      return state;
  }
};
export default reducer;
